import request from "@/utils/request";
import qs from "qs";

export const getActivityList = params =>
  request({ url: "/offlineActivity/getActivityList", method: "get", params });
export const editActivity = params =>
  request.post("/offlineActivity/editActivity", qs.stringify(params));
export const deleteActivity = params =>
  request.post("/offlineActivity/deleteActivity", qs.stringify(params));
export const getActivityGoods = params =>
  request({ url: "/offlineActivity/getActivityGoods", method: "get", params });
export const editActivityGoods = params =>
  request.post("/offlineActivity/editActivityGoods", qs.stringify(params));
export const deleteActivityGoods = params =>
  request.post("/offlineActivity/deleteActivityGoods", qs.stringify(params));
export const getQrCode = params =>
  request({ url: "/offlineActivity/qrCode", method: "get", params });
export const getActivityOrders = params =>
  request({ url: "/offlineActivity/orderList", method: "get", params });
export const pickupOrder = params => request.post("/offlineActivity/pickup", qs.stringify(params));
